import React, { useState, useContext, useRef } from "react";
import DataTable from "react-data-table-component";
import { IoCloudDownloadOutline } from "react-icons/io5";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import exportFromJSON from "export-from-json";
import dayjs from "dayjs";
import { Modal } from "react-bootstrap";
// import { FiPrinter } from "react-icons/fi";
// import ReactToPrint from "react-to-print";

//internal import
import PageHeader from "../../components/common/PageHeader";
import ModalLoading from "../../components/Loading/ModalLoading";
import useAsync from "../../hooks/useAsync";
import DropDownService from "../../services/DropDownService";
import ReportService from "../../services/ReportService";
import { allContext } from "../../context/AllContext";
import TableLoading from "../../components/Loading/TableLoading";

function ProjectReport() {

    const printRef = useRef();
    const [search, setSearch] = useState("");
    const [projectId, setProjectId] = useState("");
    const [projectStatus, setProjectStatus] = useState("");
    const [isViewModal, setIsViewModal] = useState(false);
    const [projectModalData, setProjectModalData] = useState([]);
    const [modalDataType, setModalDataType] = useState("ticket");
    const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));
    const { reportSearch, setReportSearch } = useContext(allContext);

    const { data, loading, tableLoading } = useAsync(() => ReportService.getAllProjectReportData({ projectId: projectId, search: search, projectStatus: projectStatus, fromDate: startDate, toDate: endDate, page: "", limit: "" }));
    const { data: projectDropDown } = useAsync(() => DropDownService.projectDropDown());

    let columnT = ""

    columnT = [
        {
            name: "PROJECT NAME",
            selector: (row) => row.projectName,
            sortable: true,
            cell: (row) => <b>{row.projectName}</b>
        },
        {
            name: "CATEGORY",
            selector: (row) => row.projectCategory,
            sortable: true
        },
        {
            name: "ASSIGN PERSON",
            selector: (row) => row.assignPerson,
            sortable: true,
            cell: row => <div><span className="fw-bold ms-1">{row.assignPerson}</span></div>,
        },

        {
            name: "START DATE",
            selector: (row) => row.projectStartDate,
            sortable: true
        },
        {
            name: "END DATE",
            selector: (row) => row.projectEndDate,
            // sortable: true
        },
        {
            name: "STATUS",
            selector: (row) => { },
            sortable: true,
            cell: row => <div className="d-flex justify-content-center"><span className={`badge ${row.projectStatus === "Completed" ? 'bg-success' : row.projectStatus === "Open" ? "bg-primary" : "bg-warning"}`}>{row.projectStatus}</span></div>

        },
    ];

    const modalTicketColumnT = [
        {
            name: "SUBJECT",
            selector: (row) => row?.subject,
            sortable: true,
            wrap: true,
            cell: row => <div><span className="fw-bold ms-1">{row.subject}</span></div>,
        },
        {
            name: "CLIENT",
            selector: (row) => row?.clientName,
            sortable: true,
            cell: row => <div><span className=" ms-1">{row?.clientName}</span></div>,
        },
        {
            name: "ASSIGNED",
            selector: (row) => row?.assigneeName,
            sortable: true,
            cell: row => <div><b className=" ms-1">{row.assigneeName}</b></div>,
            minWidth: "150px"
        },
        {
            name: "STATUS",
            selector: (row) => { },
            sortable: true,
            cell: row => <span className={`badge ${row.status === "Completed" ? 'bg-success' : row.status === "Hold" ? "bg-danger" : "bg-warning"}`}>{row.status}</span>
        }
    ];

    const modalTaskColumnT = [
        {
            name: "TASK",
            selector: (row) => row?.tasks || "",
            sortable: true,
            wrap: true,
            cell: row => <div><span className="fw-bold ms-1">{row?.tasks || ""}</span></div>,
        },
        {
            name: "ASSIGNED",
            selector: (row) => row?.assigneeName,
            sortable: true,
            cell: row => <div><span className=" ms-1">{row?.assigneeName}</span></div>,
            minWidth: "150px"
        },
        {
            name: "HOURS",
            selector: (row) => row?.hours,
            sortable: true,
            cell: row => <div><span className=" ms-1">{row?.hours || "-"}</span></div>,
        },
        {
            name: "STATUS",
            selector: (row) => { },
            sortable: true,
            cell: row => <span className={`badge ${row.status === "Completed" ? 'bg-success' : row.status === "Hold" ? "bg-danger" : "bg-warning"}`}>{row.status}</span>
        }
    ];

    const handleDownloadReport = async (downloadType) => {
        try {
            const res = await ReportService.getAllProjectReportData({ projectId: projectId, search: search, projectStatus: projectStatus, fromDate: startDate, toDate: endDate, page: "", limit: "" });
            if (downloadType === "pdf") {
                const exportData = res?.data?.map((val) => {
                    return [
                        val.projectName,
                        val.projectCategory,
                        val.assignPerson,
                        val.projectStartDate,
                        val.projectEndDate,
                        val.status
                    ]
                });
                const head = ["PROJECT NAME", "CATEGORY", "ASSIGN PERSON", "START DATE", "END DATE", "STATUS"];
                const unit = "pt";
                const size = "A4"; // Use A1, A2, A3 or A4
                const orientation = "landscape"; // portrait or landscape  
                const doc = new jsPDF(orientation, unit, size);
                doc.setFontSize(15);
                const headers = [head];
                let content = {
                    startY: 50,
                    head: headers,
                    body: exportData
                };

                const header = "Project Report";
                const footer = dayjs().format("DD-MM-YYYY hh:mm A");
                const pageSize = doc.internal.pageSize;
                const pageWidth = pageSize.width || pageSize.getWidth();
                const pageHeight = pageSize.height || pageSize.getHeight();

                doc.text(header, 40, 15);
                doc.text("CRM with Sunpro", 500, 15, { baseline: 'top' });
                doc.autoTable(content);
                doc.setFontSize(8);
                doc.text(footer, pageWidth / 1.2, pageHeight - 50, { baseline: 'bottom' });

                doc.save("project-report" + Date.now() + ".pdf");
            }
            else if (downloadType === "csv" || downloadType === "xls") {
                const exportData = res?.data?.map((val) => {
                    return {
                        "PROJECT NAME": val.projectName,
                        "CATEGORY": val?.projectCategory,
                        "ASSIGN PERSON": val.assignPerson,
                        "START DATE": val.projectStartDate,
                        "END DATE": val.projectEndDate,
                        "STATUS": val.status
                    }
                });
                exportFromJSON({
                    data: exportData,
                    fileName: "project-report" + Date.now(),
                    exportType: downloadType,
                });
            }
        } catch (error) {
            console.error("error", error)
        }
    }

    const handleClearFilter = () => {
        setProjectId("");
        setProjectStatus("");
        setSearch("");
        setReportSearch(!reportSearch);
    }

    const handleModalOpen = (row) => {
        setProjectModalData(row || []);
        setModalDataType("ticket");
        setIsViewModal(true);
    }


    return (
        <div className="container-xxl">
            {loading ? <ModalLoading loading={loading} /> :
                <>
                    <PageHeader headerTitle="Project Report" renderRight={() => {
                        return <div className="col-auto d-flex w-sm-100">
                        </div>
                    }} />
                    <div className="row">
                        <div className="col-lg-12 pb-4 d-flex justify-content-between">

                            <div className=" col-lg-3 p-2">
                                <label className="form-label">Search</label>
                                <input
                                    type="search"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    className="form-control"
                                    placeholder="Search Project and category"
                                    aria-label="search"
                                    aria-describedby="addon-wrapping"
                                />
                            </div>
                            <div className=" col-lg-3 p-2">
                                <label className="form-label">Start Date</label>
                                <input
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    className="form-control"
                                    placeholder="Search Project name and category"
                                    aria-label="search"
                                    max={endDate}
                                    aria-describedby="addon-wrapping" />
                            </div>
                            <div className=" col-lg-3 p-2">
                                <label className="form-label">End Date</label>
                                <input
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    min={startDate}
                                    className="form-control"
                                    placeholder="Search Project name and category"
                                    aria-label="search"
                                    aria-describedby="addon-wrapping" />
                            </div>
                            <div className=" col-lg-3 p-2">
                                <label className="form-label">Select Project</label>
                                <select className="form-select" value={projectId} onChange={(e) => setProjectId(e.target.value)}>
                                    <option value="">--- All project ---</option>
                                    {projectDropDown?.data?.map((val, idx) => (
                                        <option key={idx} value={val?.value}>{val?.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-12 pb-4 d-flex justify-content-between">
                            <div className=" col-lg-3 ">
                                <label className="form-label">Select Status</label>
                                <select className="form-select"
                                    value={projectStatus}
                                    onChange={(e) => setProjectStatus(e.target.value)}
                                >
                                    <option value="">--- All Status ---</option>
                                    <option value="Open">Open</option>
                                    <option value="In Progress">In Progress</option>
                                    <option value="Completed">Completed</option>
                                </select>
                            </div>
                            <div className="ms-5 mt-4 p-2 me-2">
                                <button className="btn btn-dark  px-4 me-2" type="submit" onClick={() => handleClearFilter()}><span className="text-white dark:text-gray-200">Reset</span></button>
                                <button className="btn btn-dark  px-4 " type="submit" onClick={() => setReportSearch(!reportSearch)}><span className="text-white dark:text-gray-200">Search</span></button>
                            </div>
                        </div>
                        <div className="col-lg-12 p-4 pt-1 mt-1 d-flex justify-content-end ">
                            <button className={`btn btn-dark btn-set-task w-sm-100 m-2 ${data?.data.length === 0 && "opacity-50"}`} onClick={() => data?.data.length !== 0 && handleDownloadReport("csv")}><span className=" me-2 fs-6"><IoCloudDownloadOutline /></span> CSV </button>
                            <button className={`btn btn-dark btn-set-task w-sm-100 m-2 ${data?.data.length === 0 && "opacity-50"}`} onClick={() => data?.data.length !== 0 && handleDownloadReport("xls")}><span className=" me-2 fs-6"><IoCloudDownloadOutline /></span>EXCEL</button>
                            <button className={`btn btn-dark btn-set-task w-sm-100 m-2 ${data?.data.length === 0 && "opacity-50"}`} onClick={() => data?.data.length !== 0 && handleDownloadReport("pdf")}><span className=" me-2 fs-6"><IoCloudDownloadOutline /></span>PDF</button>
                            {/* <ReactToPrint
                                trigger={() => (
                                    <button  className="btn btn-dark btn-set-task w-sm-100 m-2">
                                        <span className=" me-2 fs-6"><FiPrinter /></span>
                                        Print
                                    </button>
                                )}

                                content={() => printRef.current}
                                documentTitle="Invoice"
                            /> */}
                        </div>
                    </div>
                    <div className="row clearfix g-3">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body" ref={printRef}>
                                    <DataTable
                                        title="Users"
                                        columns={columnT}
                                        data={data?.data}
                                        defaultSortField="title"
                                        pagination
                                        selectableRows={false}
                                        className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                        highlightOnHover={true}
                                        progressPending={tableLoading}
                                        onRowClicked={(row) => handleModalOpen(row)}    
                                        progressComponent={<TableLoading row={10} col={7} width={160} height={20} />}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            <Modal show={isViewModal} size="xl" centered onHide={() => { setIsViewModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold w-100 text-center ">{projectModalData?.projectName} {modalDataType === "ticket" ? "Tickets" : "Tasks"}</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="col-lg-12 pb-2 d-flex justify-content-center gap-5">
                        <div >
                            <input
                                type="radio"
                                className="m-2 "
                                id="ticket"
                                style={{ transform: "scale(1.5)" }}
                                checked={modalDataType === "ticket" ? true : false}
                                onChange={(e) => setModalDataType(e.target.checked ? "ticket" : "task")}
                            />
                            <label className="form-label" for="ticket">Tickets</label>
                        </div>
                        <div >
                            <input
                                type="radio"
                                className="m-2"
                                id="tasks"
                                style={{ transform: "scale(1.5)" }}
                                checked={modalDataType === "task" ? true : false}
                                onChange={(e) => setModalDataType(e.target.checked ? "task" : "ticket")}
                            />
                            <label className="form-label text" for="tasks" >Tasks</label>
                        </div>
                    </div>
                    <div className="row clearfix g-3" >
                        <div className="col-md-12">
                            <div className="card ">
                                <div className="card-body" ref={printRef}>
                                    <DataTable
                                        title="Project Tickets"
                                        columns={modalDataType === "ticket" ? modalTicketColumnT : modalTaskColumnT}
                                        data={modalDataType === "ticket" ? projectModalData?.tickets : projectModalData?.tasks || []}
                                        defaultSortField="title"
                                        selectableRows={false}
                                        className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                        highlightOnHover={true}
                                        progressPending={loading}
                                        progressComponent={<ModalLoading loading={loading} />}
                                        fixedHeader
                                        fixedHeaderScrollHeight="440px"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ProjectReport;